// Browser-only custom event for opening form modal
export const OPEN_MODAL_EVENT = 'open-form-modal';

const normalizeParamValue = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-');

export type FormModalPayload = {
  formId: number;
  slugId: string;
  productId?: string;
  ctaId?: string;
  // Optional TypeForm fields for modal content
  badge?: string;
  title?: string;
  description?: string;
  // Optional success/thank-you screen fields
  successTitle?: string;
  successDescription?: string;
  successCTA?: {
    label?: string;
    url?: string;
    type?: 'Button' | 'Link';
  };
  thankYouUrl?: string;
};

export const openFormModal = (formContent: FormModalPayload) => {
  if (typeof window !== 'undefined') {
    // Set tracking URL params (form and state)
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.searchParams.toString());
    params.delete('contact-form');
    params.delete('state');
    params.delete('product');
    params.delete('cta');

    const orderedParams = new URLSearchParams();
    orderedParams.set('contact-form', normalizeParamValue(formContent.slugId));
    orderedParams.set('state', 'open');
    if (formContent.productId) {
      orderedParams.set('product', normalizeParamValue(formContent.productId));
    }
    if (formContent.ctaId) {
      orderedParams.set('cta', normalizeParamValue(formContent.ctaId));
    }

    for (const [key, value] of params.entries()) {
      orderedParams.append(key, value);
    }

    const newUrl = orderedParams.toString()
      ? `${url.pathname}?${orderedParams.toString()}`
      : url.pathname;
    window.history.replaceState({}, '', newUrl);

    // Dispatch event with full form data in detail
    window.dispatchEvent(
      new CustomEvent<FormModalPayload>(OPEN_MODAL_EVENT, {
        detail: formContent,
      }),
    );
  }
};
